import { foundations } from '../foundations';
const { colors, shadows } = foundations;

export const Radio = {
  baseStyle: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
    control: {
      bg: colors.background.form.default[colorMode],
      border: `1px solid ${colors.border.transparent[colorMode]}`,
      color: '#ffffff',
      _invalid: {
        border: `1px solid ${colors.border.form.critical[colorMode]}`,
      },
      _disabled: {
        bg: colors.background.form.disabled[colorMode],
        color: colors.icon.default,
      },
      _focus: {
        boxShadow: shadows.outline,
      },

      _checked: {
        bg: colors.interactive.activate,
        border: `1px solid ${colors.border.transparent[colorMode]}`,
        color: '#ffffff',
        _hover: {
          bg: colors.interactive.activate,
          border: `1px solid ${colors.border.transparent[colorMode]}`,
        },
        _invalid: {
          border: `1px solid ${colors.border.form.critical[colorMode]}`,
        },
        _disabled: {
          bg: colors.background.form.disabled[colorMode],
          color: colors.icon.default,
        },
      },

      _before: {
        bg: colors.text.white,
        _dark: {
          bg: colors.text.white,
        },
      },
    },
  }),
};
